import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectJoin',
  standalone: false
})
export class ObjectJoinPipe<T> implements PipeTransform {
  public transform(
    val: T,
    keys: Array<string>,
    deliMeter: string = ', '
  ): string {
    return (
      keys
        // @ts-ignore
        .map(_ => val[_])
        .filter(_ => !!_)
        .join(deliMeter)
    );
  }
}
